import { AppContext } from '../../common/AppContext';
import { Utils } from '../../common/Utils';
import { EmployeeSelectorList } from '../../data/filters/EmployeeSelectorList';
import { ManagerSelectorList } from '../../data/filters/ManagerSelectorList';
import {
  AbstractFilterSelectProps,
  BaseSelectorOption,
} from '../../types/components/selector.types';
import { AbstractFilterSelect } from './AbstractFilterSelect';

interface EmployeeSelectorOption extends BaseSelectorOption {
  employeeId: string;
  fullName: string;
  jobTitle: string;
}

export class EmployeeSelector<
  TOption extends EmployeeSelectorOption,
> extends AbstractFilterSelect<TOption> {
  static contextType = AppContext;

  static defaultProps = {
    ...AbstractFilterSelect.defaultProps,
    label: 'People',
    listType: 'Employees',
  };

  constructor(props: AbstractFilterSelectProps<TOption>) {
    super(props);

    this.dataList = (props.dataList ??
      (props.managersOnly
        ? ManagerSelectorList
        : EmployeeSelectorList)) as unknown as typeof this.dataList;
  }

  compareItems(a: TOption, b: TOption) {
    return a.employeeId === b.employeeId;
  }

  getItemLabel(item: TOption) {
    const {
      hasNoneItem,
      noneItemLabel,
      hasAllItem,
      allItemLabel,
      hasNewItem,
      newItemLabel,
      translate,
    } = this.props;

    if (hasNoneItem && item.isNoneItem === true)
      return noneItemLabel || (translate ? translate('common.none') : 'None');
    else if (hasAllItem && item.isAllItem === true)
      return allItemLabel || (translate ? translate('common.all') : 'All');
    else if (hasNewItem && item.isNewItem === true)
      return newItemLabel || (translate ? translate('common.new') : 'New');
    return item.fullName;
  }

  getItemSecondaryAction(item: TOption) {
    const props = this.props;
    const { theme, getItemSecondaryAction } = props;
    return getItemSecondaryAction
      ? getItemSecondaryAction(item)
      : theme && theme.isBreakpointDown('sm')
        ? null
        : Utils.truncate(item.jobTitle, theme && theme.isBreakpointUp('md') ? 30 : 20);
  }

  getList(dataList: any) {
    return dataList.employees;
  }

  findValueItem(items: TOption[], value: string) {
    if (!items || !Array.isArray(items)) return null;
    return (
      items.find(
        (c: TOption) => c.fullName === value || (c.fullName && c.fullName.includes(value))
      ) ?? null
    );
  }
}
